import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SHHETS_CONFIG } from "./sheets.config";
import { consultRegisteredIntegrations } from "../../../services/api/Integrations/listRegisteredIntegrations";
import { isFeatureAllowed } from "../../../shared/utils/featureAccess";

const ERP_ROUTE_MAP = {
  SGP: "sgp",
  "Controllr ISP": "controllr",
  HubSoft: "hubsoft",
  EliteSoft: "elitesoft",
  Sienge: "sienge",
  "IXC Soft": "ixc",
  Voalle: "voalle",
  "MK Solutions": "mksolutions",
  Atlaz: "atlaz",
  Atlas: "atlaz",
  Asaas: "asaas",
  Efi: "efi",
  EFI: "efi",
  "Efí": "efi",
  CobreFacil: "cobrefacil",
  "Cobre Fácil": "cobrefacil",
  "Receita NET": "receitanet",
  ReceitaNet: "receitanet",
  ISPFY: "ispfy",
  "LH ISP": "lhisp",
  "Superlógica Assinaturas": "superlogica",
  Superlogica: "superlogica",
  ssOtica: "ssotica",
};

const ERP_DEFAULT_FEATURES = [
  "Sincronização automática",
  "Listagens em tempo real",
  "Integração direta com o sistema",
  "Atualização contínua das informações",
];



function mapERPToSheetOption(erp) {
  return {
    key: `erp_${erp.integration_title}`,
    title: erp.integration_title,
    subtitle: "Integração ERP",
    text: "Crie listagens diretamente a partir do seu ERP integrado.",
    icon: erp.integration_logo,
    tag: "ERP",
    route: `/listagens/adicionar/${ERP_ROUTE_MAP[erp.integration_title]}`,
    status: erp.status,
    features: ERP_DEFAULT_FEATURES
  };
}

function uniqueErpsByTitle(items = []) {
  const byTitle = new Map();

  items.forEach((item) => {
    const title = item?.integration_title;
    if (!title || byTitle.has(title)) return;
    byTitle.set(title, item);
  });

  return Array.from(byTitle.values());
}


export function useSheetsOptions(featureAccess) {
  const navigate = useNavigate();
  const [erpOptions, setErpOptions] = useState([]);
  const [isLoadingErp, setIsLoadingErp] = useState(false);

  useEffect(() => {
    setIsLoadingErp(true);
    consultRegisteredIntegrations()
      .then((response) => {
        const mapped = uniqueErpsByTitle(response.data).map(mapERPToSheetOption);
        setErpOptions(mapped);
      })
      .catch(() => {
        setErpOptions([]);
      })
      .finally(() => {
        setIsLoadingErp(false);
      });
  }, []);

  const baseOptions = SHHETS_CONFIG.filter(
    (i) => i.key !== "add_integration"
  );

  const addIntegration = SHHETS_CONFIG.find(
    (i) => i.key === "add_integration"
  );

  const mergedOptions = [
    ...baseOptions,
    ...erpOptions,
    addIntegration,
  ].filter(Boolean);

  const sheetsData = mergedOptions.map((template) => ({
    ...template,
    alreadyPaid:
      isFeatureAllowed(featureAccess, template.key, true) ||
      (template.tag === "ERP" && isFeatureAllowed(featureAccess, "ERP", true)),
    handleClick: () => navigate(template.route),
  }));

  return { sheetsData, isLoadingErp };
}
